module.exports = __webpack_public_path__ + "img/icon-laundry.6b1b960c.svg";